var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"model-16"},[_c('div',{staticClass:"blank",style:({backgroundColor:_vm.editablePageConfig.editable_page_config_content.back_color,height:_vm.editablePageConfig.editable_page_config_content.height+'px'})})])}
var staticRenderFns = []

export { render, staticRenderFns }